import { TOGGLE_RIGHT_SIDEBAR } from 'constants/action_types'

export function doToggleRightSidebar() {
  return {
    type: TOGGLE_RIGHT_SIDEBAR,
  }
}
